import React, { useEffect, useState } from 'react'
import Modal from '../../Modal'
import { Divider, Button, Typography, Chip, Autocomplete, TextField, Alert } from '@mui/material'
import { Unstable_NumberInput as NumberInput,  NumberInputProps,  numberInputClasses  } from '@mui/base/Unstable_NumberInput';
import { useScreenerContext } from '../context/useScreenerContext'
import { useScreenersContext } from '../context/useScreenersContext'
import { usePaletteTheme } from '../../../context/paletteTheme'
import useScreenerFilters from '../hooks/useScreenerFilters'
import AutocomplateButton from '../../ui/AutocomplateButton'
import ButtonActive from '../../ui/Button'
import SectionAlternativeData from './SectionAlternativeData'
import SectionFinancialKPIData from './SectionFinancialKPIData'
import SelectButton from '../../ui/alternativeData/SelectButton'
import styles from './ScreenerFiltersModal.module.scss'
import { Height } from '@mui/icons-material'
import ScreenerFiltersChange from './ScreenerFiltersChange'
import SelectNumber from '../../ui/SelectPositiveIntegerNumber'

export default function ScreenerFiltersModal({open, handleClose, title, handleUpdateFilters}) {
    const { modalSectorsList, modalDataset, updateSectorList, modalMarketCap, modalExchange, updateModalExchange,modalMicCode, updateModalMicCode, updateModalMarketCap,modalFinancialKPI, updateTopBottomLimitOn,updateTopBottom,topLimit, bottomLimit,limitsOn,TopBottomLimitOPtions, updateTopBottomLimitOnOptions,removeTopBottomLimitsOnOptions } = useScreenerContext()
    const { sectors, datasets, mic_codes } = useScreenersContext()
    const { marketCapOptions, exchangeOptions, FinancialKPIsOptions } = useScreenerFilters()
    const { colors } = usePaletteTheme()
    const [selectedLimitsOn, setSelectedLimitsOn] = useState(limitsOn)
    const [AlertMessage, setAlertMessage] = useState('')

    useEffect(() => {
        let tempdata = []
        modalDataset?.map(dataset=>{
            dataset.datasetName&&tempdata.push({'label':`${dataset.datasetName} - ${dataset.columnName}`,value:dataset.columnValue})
        })
        modalMarketCap.length>0? tempdata.push({'label':'Market Cap','value':'market_cap'}):removeTopBottomLimitsOnOptions('market_cap')
        updateTopBottomLimitOnOptions(tempdata)
        if (limitsOn)setSelectedLimitsOn(limitsOn)
        return () => {}
    }, [modalDataset,modalMarketCap,limitsOn])
    
    // const [TopBottomLimitOPtions, setTopBottomLimitOPtions] = useState([])

    // const TopBottomLimitOPtions = [
    //     {label: 'Price',id:0},
    //     {label: 'Market Cap',id:1},
    // ]

    const handleRemoveChip = (chip) => {
        const filterd = modalSectorsList.filter(sector => sector !== chip)
        updateSectorList(filterd)
    }
    const handleRemoveExchangeChip = (chip) => {
        const filterd = modalExchange.filter(sector => sector !== chip)
        updateModalExchange(filterd)
    }

    const handleRemoveMicCodeChip = (chip) => {
        const filterd = modalMicCode.filter(sector => sector !== chip)
        updateModalMicCode(filterd)
    }
    const handleRemoveMarketcapChip = (chip) => {
        const filterd = modalMarketCap.filter(mcap => mcap !== chip)
        updateModalMarketCap(filterd)
    }

    const handleFindStocks = () => {
        if (selectedLimitsOn['value'] || limitsOn['value']){
            if (!topLimit & !bottomLimit){
                setAlertMessage("Please enter Top and Bottom limit or Clear the Limits on Field.")
                return
            }
        }
        else {
            if (topLimit || bottomLimit){
                setAlertMessage("Please select Limits on Field or Clear the Top and Bottom Fields!")
                return
            }
        }
        handleUpdateFilters()
        handleClose('submit')
        setAlertMessage('')
        // updateTopBottomLimitOnOptions('')    
    }

    const buttons = [
        <Button key="screener-cancel" variant="outlined" onClick={()=>handleClose('cancel')}>Cancel</Button>,
        <Button key="screener-add" variant="contained" color='active' onClick={handleFindStocks}>Find Companies</Button>,
    ]

    return (
        <Modal open={open} handleClose={()=>handleClose('cancel')} limitWidth={false} title={title} buttons={buttons}>
            <div className={styles['filters-modal']}>
                <Section>
                    <div className={styles['limit-size']}>
                        <AutocomplateButton options={sectors} value={modalSectorsList} setValue={updateSectorList} name='sector' allKey="Select All" shouldHaveAll>
                            <SelectButton elevation={5} value='Select sectors...' label='Choose a Sector' extraStyles={{button: [styles['sector-btn']]}}/>
                        </AutocomplateButton>
                    </div>
                    <div className={styles['chips']}>
                        {modalSectorsList?.map((sector)=> <Chip key={sector} label={sector} onDelete={() => handleRemoveChip(sector)} />)}
                    </div>
                </Section>
                <Section label="Alternative Data">
                    <SectionAlternativeData datasets={datasets} dataset={modalDataset}/>
                </Section>
                <Section label="Financial KPI Data">
                    <SectionFinancialKPIData dataset={modalFinancialKPI} FinancialKPIsOptions={FinancialKPIsOptions} />
                </Section>
                <Section label="Financial Data" >
                    <div className={styles['financial-data-container']}>
                        <div>
                            <AutocomplateButton options={marketCapOptions} value={modalMarketCap} setValue={updateModalMarketCap} name='marketCap'>
                                <ButtonActive root={styles['btn-active']} outlinecolor={colors.textPrimary} $active={modalMarketCap?.length}>Market Cap</ButtonActive>
                            </AutocomplateButton>
                            <div className={styles['chips']}>
                                {modalMarketCap?.map((cap)=> <Chip key={cap} label={cap} onDelete={() => handleRemoveMarketcapChip(cap)} />)}
                            </div>
                        </div>
                        {/* <div>
                            <AutocomplateButton options={exchangeOptions} value={modalExchange} setValue={updateModalExchange} name='exchange'>
                                <ButtonActive root={styles['btn-active']} outlinecolor={colors.textPrimary} $active={modalExchange?.length}>Exchange</ButtonActive>
                            </AutocomplateButton>
                            <div className={styles['chips']}>
                                {modalExchange.map((exchange)=> <Chip key={exchange} label={exchange} onDelete={() => handleRemoveExchangeChip(exchange)} />)}
                            </div>
                        </div> */}
                        <div>
                            <AutocomplateButton options={mic_codes} value={modalMicCode} setValue={updateModalMicCode} name='mic_code'>
                                <ButtonActive root={styles['btn-active']} outlinecolor={colors.textPrimary} $active={modalMicCode?.length}>Mic Code</ButtonActive>
                            </AutocomplateButton>
                            <div className={styles['chips']}>
                                {modalMicCode?.map((mic_code)=> <Chip key={mic_code} label={mic_code} onDelete={() => handleRemoveMicCodeChip(mic_code)} />)}
                            </div>
                        </div>
                    </div>
                </Section>
                <Section label="Top/Bottom Limits" showDivider={false}>
                    <div style={{display:'flex'}}>
                        <div style={{width:100, marginRight:30}}>
                            Top <SelectNumber  label={'Top Limit'} value={topLimit} setValue={updateTopBottom} fieldName='top'/>
                            {/* Top <input /> */}
                        </div>
                        <div style={{width:100, marginRight:30}}>
                            Bottom <SelectNumber label={'Bottom Limit'} value={bottomLimit} setValue={updateTopBottom} fieldName='bottom'/>
                            {/* Bottom <input /> */}
                        </div>
                        <div className={styles['limit-size']}>
                            Apply Limits On
                            <Autocomplete
                                size='small'
                                disablePortal
                                id="combo-box-demo"
                                value={selectedLimitsOn['label']}
                                // defaultValue={selectedLimitsOn}
                                // setValue={updateSelect}
                                options={TopBottomLimitOPtions}
                                renderInput={(params) => <TextField {...params} label='' />}
                                onChange={(e,v)=>{
                                    v?setSelectedLimitsOn(v):setSelectedLimitsOn({'label':'','value':''});
                                    v?updateTopBottomLimitOn(v):updateTopBottomLimitOn({'label':'','value':''})
                                }}            

                            />
                        </div>
                    </div>
                </Section>
                {AlertMessage && <Alert style={{backgroundColor:'#404040',color:'white'}} severity="error" onClose={()=>setAlertMessage('')}>{AlertMessage}</Alert>}
                <br />
            </div>
        </Modal>
    )
}


const Section = ({label, showDivider = true, children}) => {
    return (
        <div className={styles['section']}>
            <Typography classes={{root: styles['section-label']}}>{label}</Typography>
                {children}
                {showDivider && <Divider/>}
        </div>
    )
}